module.exports = __webpack_public_path__ + "img/H1.34472b7c.png";